









































import Vue from "vue";
import { mapState } from "vuex";
import { Component, Prop } from "vue-property-decorator";
import { ICountry, IRegion } from "@/models/constants";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      regions(state: IState, getters) {
        return getters[`constants/getRegions`](
          this.$_.get(this.country, "code")
        );
      }
    })
  }
})
export default class RegionCheckList extends Vue {
  // getters
  public regions!: IRegion[];

  @Prop({ required: true })
  public value!: IRegion["id"][];

  @Prop({ required: true })
  public country!: ICountry;

  @Prop({ required: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public loading!: boolean;

  // Computed

  public get regionIds(): IRegion["id"][] {
    return this.value;
  }

  public set regionIds(value: IRegion["id"][]) {
    this.$emit("input", value);
  }

  public get hasCheckedValues() {
    return !!this.regionIds?.length;
  }

  public get availableRegionIds() {
    return this.regions?.map(i => i.id);
  }

  public get isAllSelected() {
    return this.availableRegionIds?.every(i => this.regionIds.includes(i));
  }

  // Methods

  public toggleAll() {
    if (this.isAllSelected) this.regionIds = [];
    else this.regionIds = this.availableRegionIds;
  }
}
